// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2YTag","buttons":"SendReceipts_buttons__23GXx","email":"SendReceipts_email__PdsrN","bookApptTitle":"SendReceipts_bookApptTitle__2_LsK"};